export default __webpack_public_path__ + "static/media/waveDesign.07217733.svg";